<template>
  <div class="home container">
    <section class="hero is-dark" :style="{'background-image': 'url(' + require('../assets/environment_impact.jpg') + ')'}">
      <div class="hero-body">
        <div class="container">
          <h1 class="title main-title">{{ $t('main.welcometoevitylocal') }}</h1>
          <h2 class="subtitle main-subtitle">
            {{ $t('main.makeanimpactontheworld') }}
          </h2>
          <div class="button-block">
<!--            <router-link to="/something">-->
<!--              <button class="button is-xl is-dark">-->
<!--                {{ $t('main.suggestsomething') }}-->
<!--              </button>-->
<!--            </router-link>-->
          </div>
        </div>
      </div>
    </section>
    <section v-if="posts.length > 0">
      <div class="hero-body">
        <div class="container">
          <div class="box">
            <div class="title">{{ $t('main.Blog')}}</div>
          </div>
          <div class="container" v-for="post in posts" :key="post.id">
            <div class="card">
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-96x96">
                      <img :src="post.image" alt="BlogImage">
                    </figure>
                  </div>
                  <div class="media-content has-text-left">
                    <p class="title is-4">{{ post.title }}</p>
                    <p class="subtitle is-6">{{ post.author_detail.first_name }} {{ post.author_detail.last_name }} {{ post.tsCreated.substr(0,10) }}</p>
                  </div>
                </div>
              </div>
              <div class="content has-text-justified" style="margin-left:10px;margin-right:10px;margin-bottom:10px;padding:10px;">
                {{ post.article }} <a :href="post.weblink" target="_blank">{{ $t('main.readmore') }}</a>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
<!--    <EventsList />-->
<!--    <KpiTypeLegend />-->
  </div>
</template>
<script>
import api from '@/services/api';

export default {
    name: 'HomeView',
    data() {
      return {
        posts: [],
      }
    },
    components: {
    },
    computed: {
    },
    methods: {
      async readData() {
        try {
          const rv = await api.blogposts.fetch();
          console.log(rv);
          this.posts = rv.results;
          this.posts = this.posts.slice(0, 10);
        } catch {
          console.log("Most likely the backend is not available.")
        }
      }
    },
  mounted() {
      this.readData();
  }
  };
</script>
<style lang="scss" scoped>
  .hero {
    text-align: center;
    /*background-image: url('./assets/environment_impact.jpg');*/
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 400px;
  }
  .hero-body .main-title {
    //text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.6);
    padding: 40px 0 20px 0;
    font-size: 60px;
  }
  .main-subtitle {
    //text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.7);
    font-size: 30px;
    color: #000000 !important;
  }
  .button-block {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    position: absolute;
    bottom: -150px;
    .button {
      //margin-right: 50px;
      padding-left: 50px;
      padding-right: 50px;
    }
    .welcome {
      width: 400px;
      padding: 10px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .is-xl {
    font-size: 1.7rem;
  }
</style>